import { REPUBS } from '@cx-modules/constants';
import type { Repub } from '@cx-modules/types';

export const findRepubInUrls = (baseUrl: string | undefined, eventUrl: string, repub: Repub) => {
  const repubNames = Object.values(REPUBS).map(config => config.name.toLowerCase());
  const regex = new RegExp(`\\b(${repubNames.join('|')})\\b`, 'gi');
  const repubInEventUrl = eventUrl?.match(regex);

  if (repubInEventUrl) {
    return eventUrl;
  }
  if (!repubInEventUrl) {
    return `/${repub.toLowerCase()}${eventUrl}`;
  }
};
